module.exports = __webpack_public_path__ + "static/second-17b3859e75752ce4a17f63b74acdb2cd.svg";